import React from 'react';
import ProgressNotesEdit from '../../containers/ProgressNotes/ProgressNotesEdit';

const ProgressNotesNurseEdit = () => {
    return (
        <ProgressNotesEdit isNurse = {true}/>
    );
};
export default ProgressNotesNurseEdit;
